module.exports = __webpack_public_path__ + "static/img/4.3cda711.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/zh/4.png
// module id = CFbF
// module chunks = 0